"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CASHOUT_BACKEND_ERRORS = exports.TIME_DELAY_MAKE_CASHOUT = exports.DEFAULT_ERROR = exports.CALENDAR_DATA_FORMAT = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
exports.CALENDAR_DATA_FORMAT = 'YYYY-MM-DD';
exports.DEFAULT_ERROR = 'something went wrong try again';
exports.TIME_DELAY_MAKE_CASHOUT = 4000;
exports.CASHOUT_BACKEND_ERRORS = {
    [betweb_openapi_axios_1.ErrorCode.ClientInvalidAccount]: exports.DEFAULT_ERROR,
    [betweb_openapi_axios_1.ErrorCode.CashoutNotAllowed]: exports.DEFAULT_ERROR,
    [betweb_openapi_axios_1.ErrorCode.IncorrectCashoutAmount]: 'bet amount has changed',
    [betweb_openapi_axios_1.ErrorCode.CashoutNotAvailable]: 'selling bet is no available',
    [betweb_openapi_axios_1.ErrorCode.Unknown]: exports.DEFAULT_ERROR,
};
//# sourceMappingURL=constants.js.map